import { Message, MessageType, MessageTypeValue } from '../dataType';

export type TransformContent = {
  [key in MessageType]?: (data: any) => Pick<Message<MessageTypeValue[key]>, 'content' | 'title'>
}

export default {
  'ai.noneData': (data) => {
    return {
      content: {
        docs: data.docs.map((name: string, index: number) => ({
          name,
          id: index
        })),
        header: data.title
      },
      title: data.title
    };
  },
  'ai.markdown': (data) => {
    return {
      content: {
        header: data.base.source || '',
        content: data.content
      },
      title: data.title
    };
  },
  'ai.receiveRecommendData': (data) => {
    return {
      content: {
        recommend: data.recommend,
        filterOptions: data.filterOptions,
        gptResponse: data.gptResponse,
        params: data.params,
        intent: data.base.intentCode,
        taskId: data.base.taskId,
        base: data.base,
        recommendType: data.recommendType || ''
      },
      title: data.header
    };
  },
  'ai.receiveRecommendDataFilter':(data) => {
    return {
      content: {
        recommend: data.recommend,
        gptResponse: data.gptResponse,
        filterOptions: data.filterOptions,
        params: data.params,
        intent: data.base.intentCode,
        taskId: data.base.taskId,
        base: data.base
      },
      title: data.header
    };
  },
  'ai.sprint.risk.status': (data) => {
    return {
      content: {
        actionType: data.actionType,
        recommend: data.recommend,
        intent: data.base.intentCode,
        taskId: data.base.taskId,
        base: data.base
      },
      title: data.header
    };
  },
  'ai.text': (data) => {
    return {
      content: data.content
    };
  },
  'ai.input.text': (data) => {
    return {
      content: data.text
    };
  },
  'ai.example': (data) => {
    return {
      content: {
        mainText: data.header,
        intent: data.example.intent,
        questionList: data.example.value
      }
    };
  },
  'ai.issue': (data) => {
    return {
      content: {
        list: data.issueResult.data,
        total: data.issueResult.total,
        content: data.content,
        params: data.issueResult.params
      },
      title: data.header
    };
  },
  'ai.automation': (data) => {
    return {
      content: {
        rule: data.robotTalkVO.rule,
        base: data.base,
        content: data.content
      },
      title: data.tip
    };
  },
  'ai.automation.error': (data) => {
    return {
      content: {
        header: data.base.source || '',
        content: data.content
      },
      title: data.title
    };
  },
  'ai.automation.ask.project': (data) => {
    return {
      content: {
        projects: data.projects.map((item: any, index: number) => ({
          projectName: item.projectName,
          id: index,
          projectId: item.projectId || 0
        })),
        base: data.base
      }
    };
  },
  'ai.receive.report.data': (data) => {
    return {
      content: {
        base: data.base,
        report: data.report || data.error
      }
    };
  }
} as TransformContent;
